/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:17:05
*/


const contextParametersReducer = (state = {}, action) => {
	if(action.type === 'SET_CONTEXT_PARAMETERS') {
		var newState = {};
		Object.assign(newState,state);
		newState[action.key] = action.payload;
		return newState;
	}else {
		return state
	}
}

export default contextParametersReducer;
